import { MAIN_REASONS, PATH_TYPES } from "./sanctionConstants";

const MainReasonSelector = ({
  mainReasons,
  mainReasonsConfig,
  selectedReason,
  selectedPathType,
  onReasonChange,
  onPathTypeChange,
  confirmNotBusinessCreation,
  onConfirmNotBusinessCreationChange,
}) => {
  return (
    <div className="mb-4">
      <div className="p-3 rounded" style={{ background: "#f8f9fa" }}>
        <label className="font-weight-bold mb-2" style={{ fontSize: 14 }}>
          Motif principal <span className="text-danger">*</span>
        </label>

        <div className="d-flex flex-column" style={{ gap: 10 }}>
          {Object.values(mainReasons).map((reason) => {
            const reasonConfig = mainReasonsConfig.find(
              (r) => r.id === reason.id,
            );
            const hasError = reasonConfig?.erreur;
            return (
              <div key={reason.id}>
                <button
                  type="button"
                  className={`btn border text-left ${
                    selectedReason === reason.id ? "btn-primary" : "btn-default"
                  }`}
                  style={{
                    opacity: hasError ? 0.6 : 1,
                    cursor: hasError ? "not-allowed" : "pointer",
                  }}
                  onClick={() => {
                    if (!hasError) {
                      onReasonChange(reason.id);
                    }
                  }}
                >
                  {reason.label}
                </button>
                {hasError && (
                  <div
                    className="alert alert-warning mt-2 mb-0"
                    style={{ fontSize: 13, padding: "8px 12px" }}
                  >
                    <small>⚠️ {reasonConfig.erreur}</small>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {selectedReason === MAIN_REASONS.REFUS_OFFRE_RAISONNABLE_EMPLOI.id && (
          <div className="mt-3">
            <label className="font-weight-bold mb-2" style={{ fontSize: 14 }}>
              Type de parcours de l'allocataire{" "}
              <span className="text-danger">*</span>
            </label>
            <p
              className="text-muted mb-2"
              style={{ fontSize: 13, fontStyle: "italic" }}
            >
              Cette information est requise pour le motif sélectionné
            </p>
            <div className="d-flex flex-wrap" style={{ gap: 10 }}>
              {Object.values(PATH_TYPES).map((pathType) => (
                <button
                  key={pathType.id}
                  type="button"
                  className={`btn ${
                    selectedPathType === pathType.id
                      ? "btn-primary"
                      : "btn-default"
                  }`}
                  onClick={() => onPathTypeChange(pathType.id)}
                >
                  {pathType.label}
                </button>
              ))}
            </div>
            {selectedPathType === PATH_TYPES.SOCIAL.id && (
              <div className="alert alert-danger mt-3" style={{ fontSize: 14 }}>
                ⚠️ <strong>Inscription impossible :</strong> Motif non valable
                pour les bénéficiaires en parcours social.
              </div>
            )}
            {(selectedPathType === PATH_TYPES.PROFESSIONNEL.id ||
              selectedPathType === PATH_TYPES.SOCIO_PROFESSIONNEL.id) && (
              <div className="mt-3">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="confirmNotBusinessCreation"
                    checked={confirmNotBusinessCreation}
                    onChange={(e) =>
                      onConfirmNotBusinessCreationChange(e.target.checked)
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor="confirmNotBusinessCreation"
                    style={{ fontSize: 14 }}
                  >
                    Je confirme qu'il ne s'agit pas d'une création ou une
                    reprise d'entreprise
                  </label>
                </div>
                {!confirmNotBusinessCreation && (
                  <div
                    className="alert alert-warning mt-2"
                    style={{ fontSize: 13, padding: "8px 12px" }}
                  >
                    ⚠️ Motif non valable pour les bénéficiaires souhaitant
                    reprendre ou créer une entreprise.
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MainReasonSelector;
